import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { Payment, ProductData } from '../types';
import { TrackingPixels } from '../types/pixels';

const useGoogleAds = () => {
  const { id } = useParams<{ id: string }>();
  const queryClient = useQueryClient();
  const offer = queryClient.getQueryData(['checkout', id]) as ProductData;

  const pixels =
    (offer?.tracking_pixels?.google_ads_pixels as TrackingPixels['google_ads_pixels']) || [];

  const getPaymentValue = (payment: Payment): number => {
    const n = Number(payment?.amount);
    if (Number.isFinite(n)) return n;
    const orders = Array.isArray(payment?.orders) ? payment.orders : [];
    return orders.reduce((acc: number, o) => acc + Number(o?.amount || 0), 0);
  };

  const onTicketGenerated = (payment: Payment): void => {
    const value: number = getPaymentValue(payment);
    pixels.forEach((pixel) => {
      if (!pixel.boletoTrigger) return;
      //@ts-ignore
      window.gtag('event', 'conversion', {
        send_to: `${pixel.pixelId}/${pixel.conversionLabel}`,
        value,
        currency: 'BRL',
        transaction_id: payment?.id,
        event_category: 'Boleto',
        event_action: 'Gerado',
        event_label: 'Boleto Gerado',
      });
    });
  };

  const onPixGenerated = (payment: Payment): void => {
    const value: number = getPaymentValue(payment);
    pixels.forEach((pixel) => {
      if (!pixel.cardPixApprovalTrigger) return;
      //@ts-ignore
      window.gtag('event', 'conversion', {
        send_to: `${pixel.pixelId}/${pixel.conversionLabel}`,
        value,
        currency: 'BRL',
        transaction_id: payment?.id,
        event_category: 'PIX',
        event_action: 'Gerado',
        event_label: 'PIX Gerado',
      });
    });
  };

  const onCheckoutVisit = (): void => {
    pixels.forEach((pixel) => {
      if (!pixel.checkoutVisitTrigger) return;
      //@ts-ignore
      window.gtag('event', 'conversion', {
        send_to: `${pixel.pixelId}/${pixel.conversionLabel}`,
        event_category: 'Checkout',
        event_action: 'Visitado',
        event_label: 'Visita ao Checkout',
      });
    });
  };

  const onPaymentApproved = (payment: Payment, amount: number): void => {
    const value: number = Number.isFinite(amount) ? Number(amount) : getPaymentValue(payment);
    pixels.forEach((pixel) => {
      if (!pixel.cardPixApprovalTrigger) return;
      //@ts-ignore
      window.gtag('event', 'conversion', {
        send_to: `${pixel.pixelId}/${pixel.conversionLabel}`,
        value,
        currency: 'BRL',
        transaction_id: payment?.id,
        event_category: 'Pagamento',
        event_action: 'Aprovado',
        event_label: 'Pagamento Aprovado',
      });
    });
  };

  return {
    onTicketGenerated,
    onPixGenerated,
    onCheckoutVisit,
    onPaymentApproved,
  };
};

export { useGoogleAds };
